import React, { useState, useEffect } from "react";
import { Modal, Box, Typography } from "@mui/material";
import MyButton from "../../components/myButton";
import MyInput from "../../components/myInput";
import MySelect from "../../components/mySelect";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  height: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

function ModalRelatorioAdd({ open, onClose, onGerar }) {
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const [nomeRelatorio, setNomeRelatorio] = useState("");
  const [condicao, setCondicao] = useState(1); 

  // Preenche a data com hoje ao abrir o modal
  useEffect(() => {
    if (open) {
      let hoje = new Date()
      let formatadaInicio = hoje.toLocaleDateString('en-CA') +' 00:00:00'
      let formatadaFim = hoje.toLocaleDateString('en-CA') +' 23:59:00'           

      setDataInicio(formatadaInicio)
      setDataFim(formatadaFim)      
      setNomeRelatorio("");
    }
  }, [open]);

  const handleConfirmar = () => {
    let data = new Date(dataInicio);
    let pad = (n) => n.toString().padStart(2, '0');
    let dataFormatadaInicio = `${pad(data.getDate())}/${pad(data.getMonth() + 1)}/${data.getFullYear()} ${pad(data.getHours())}:${pad(data.getMinutes())}:00`;

    let _dataFim = new Date(dataFim);
    let padFim = (n) => n.toString().padStart(2, '0');
    let dataFormatadaFim = `${pad(_dataFim.getDate())}/${padFim(_dataFim.getMonth() + 1)}/${_dataFim.getFullYear()} ${padFim(_dataFim.getHours())}:${padFim(_dataFim.getMinutes())}:00`;

    let tipo = "";
    if (condicao === 1) {
      tipo = 'TAREFAS'
    }

    onGerar({
      nome: nomeRelatorio,
      tipo_relatorio: tipo,
      data_inicial: dataFormatadaInicio,
      data_final: dataFormatadaFim,
      origem:'MANUAL'
    });
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" component="h2" gutterBottom>
          Defina um período para gerar seu relatório.
        </Typography>
        <Box sx={{display: 'flex', marginTop:3, flexDirection: 'column', gap: 2, height: '80%' }}>
          <MySelect
            id='tipo'
            size="medium"
            label='Opções de Relatórios'
            options={[ 
                {id:1, nome:'Relatório de Tarefas'}
            ]}
            value={condicao}
            onChange={(e)=>{setCondicao(e.target.value)}}
            disabled={true}
          />          
          <MyInput
            label="Descrição do Relatório"
            type="text"
            value={nomeRelatorio}
            onChange={(e) => setNomeRelatorio(e.target.value.toUpperCase())}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />


          <Box sx={{ display: 'flex', justifyContent: 'space-between'}}>
            <MyInput
              sx={{marginRight: 2}}
              label="Data Inicio"
              type="datetime-local"
              value={dataInicio}
              onChange={(e) => setDataInicio(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            <MyInput
              label="Data Fim"
              type="datetime-local"
              value={dataFim}
              onChange={(e) => setDataFim(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 0 }}>
            <MyButton
              onClick={onClose}
              variant="contained"
              text="Voltar"
              color="warning"
            />
            <MyButton
              onClick={handleConfirmar}
              variant="contained"
              text="Gerar Relatório"
              color="success"
              disabled={nomeRelatorio.length < 10} 
            />
          </Box>
        </Box>

      </Box>
    </Modal>
  );
}

export default ModalRelatorioAdd;
